import * as schemaLabels from "~/schemas/schema.labels.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const addLabel = (attributes) => {
  return {
    types: [actionTypes.ADD_LABEL_LOADING, actionTypes.ADD_LABEL_SUCCESS, actionTypes.ADD_LABEL_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/labels`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: {
        single: schemaLabels.label,
      },
    },
  };
};

export const addLabelToProject = (projectId, label) => {
  return {
    type: actionTypes.ADD_LABEL_TO_PROJECT,
    schema: schemaLabels.label,
    response: label.toObject(),
    projectId,
  };
};

export const editLabelAction = (id, attributes) => ({
  types: [actionTypes.EDIT_LABEL_LOADING, actionTypes.EDIT_LABEL_SUCCESS, actionTypes.EDIT_LABEL_ERROR],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/labels/${id}`,
      method: `put`,
      body: attributes,
    }),
  payload: {
    id,
    attributes,
    schema: {
      single: schemaLabels.label,
    },
  },
});

export const deleteLabelAction = (id) => ({
  types: [actionTypes.DELETE_LABEL_LOADING, actionTypes.DELETE_LABEL_SUCCESS, actionTypes.DELETE_LABEL_ERROR],
  callAPI: () =>
    fetch({
      url: `${Angie.api_url}/labels/${id}`,
      method: `DELETE`,
    }),
  payload: {
    id,
  },
});

export const addLabelFromEventStream = (data) => {
  return {
    type: actionTypes.ADD_LABEL_FROM_EVENT_STREAM,
    response: data,
    schema: schemaLabels.label,
  };
};

export const updateLabelFromEventStream = (data) => {
  return {
    type: actionTypes.UPDATE_LABEL_FROM_EVENT_STREAM,
    response: data,
    schema: schemaLabels.label,
  };
};

export const deleteLabelFromEventStream = (data) => {
  return {
    type: actionTypes.DELETE_LABEL_FROM_EVENT_STREAM,
    response: data,
    schema: schemaLabels.label,
  };
};
